module.exports = __webpack_public_path__ + "img/guizhouHints_11.20c972ab.jpg";